module.exports = __webpack_public_path__ + "img/background_mobile.30974f7d.png";